import { isFilename } from '__core/shared/util/validate';
import template from './documentRename.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, documentService, uiService, Document) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onDocumentRename(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                document: _params.document ? angular.copy(_params.document) : Document.Blank()
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (document) {
              documentService
                .updateDocument({ id: document.id, name: document.name })
                .then(function (data) {
                  if (data.status) {
                    ctrl.onFinished({ document: document });
                    uiService.toast({
                      text: {
                        p1: 'Merge template',
                        p2: document.getName(),
                        p3: 'has been renamed'
                      }
                    });
                  }
                });
            });

          function dialogController($mdDialog, document) {
            this.document = document;
            this.documentName = document.getNameWithoutExtension();
            this.documentExtension = document.getFileExtension();
            this.confirm = function () {
              if (this.documentName !== '') {
                if (isFilename(this.documentName)) {
                  this.document.name = this.documentName + '.' + this.documentExtension;
                  $mdDialog.hide(this.document);
                } else {
                  uiService.toast({
                    text: {
                      p1: 'Merge template',
                      p2: 'name',
                      p3: 'contains invalid characters'
                    },
                    warn: true
                  });
                }
              } else {
                uiService.toast({
                  text: {
                    p1: 'Merge template',
                    p2: 'name',
                    p3: 'is required'
                  },
                  warn: true
                });
              }
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
